import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { initPostHog } from './lib/posthog';
import { initGtm } from './lib/gtm';
const PAGE_TITLE = 'Caveo // The home IT department for families';
const PAGE_DESCRIPTION = 'Caveo is building a household system for digital safety. Clear next steps for every person, and help keeping them current. Launching soon.';
document.title = PAGE_TITLE;
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}
setMeta('name', 'description', PAGE_DESCRIPTION);
setMeta('name', 'robots', 'index, follow');

// Point search engines at the single canonical page (the site root).
let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
if (!canonical) {
  canonical = document.createElement('link');
  canonical.rel = 'canonical';
  document.head.appendChild(canonical);
}
canonical.href = `${window.location.origin}/`;
setMeta('property', 'og:title', PAGE_TITLE);
setMeta('property', 'og:description', PAGE_DESCRIPTION);
setMeta('name', 'twitter:title', PAGE_TITLE);
setMeta('name', 'twitter:description', PAGE_DESCRIPTION);
initGtm();
initPostHog();
render(<AppRouter data-id="element-418" data-mp="1tc6fbwkd4h4w" />, document.getElementById('root'));